<div class="layout-head">
  <div class="layout-gutter-left">
  </div>
  <div class="layout-content">
    @if (showRelatedItemsScrollArea) {
      <nts-text-button  (click)="scrollLeft()" icon="arrow-back"></nts-text-button>
    }
    <div class="nts-container" #itemListContainer>
      @if (!showTitle) {
        <div class="tab-container" role="heading" >
          @if (relatedItemList$) {
            <p-tabMenu [model]="relatedItemList$ | async" [activeItem]="activeRelatedItem">
              <ng-template pTemplate="item" let-item let-i="index">
                @if (item.visible) {
                  <a class="p-menuitem-link">
                    <span
                      popper="{{item.label}}"
                      [popperTrigger]="ngxPopperjsTriggers.hover"
                      [popperDelay]="1000"
                      popperApplyClass="info"
                      [popperPlacement]="ngxPopperjsPlacements.TOP"
                      [popperPreventOverflow]="false"
                      [popperHideOnScroll]="true"
                      popperAppendTo="body"
                    >{{item.label}}</span>
                  </a>
                }
              </ng-template>
            </p-tabMenu>
          }
        </div>
      }
      @if (showTitle && orchestratorViewModel?.title?.length > 0) {
        <div class="title-container" [attr.tabindex]="0"  role="heading" aria-level="1">
          @if ($safeNavigationMigration(orchestratorViewModel?.customIcon$) | async; as customIcon) {
            <span class ="icon-field"
              [popper]="customIcon.tooltip?.description ?? null"
              [popperTrigger]="ngxPopperjsTriggers.hover"
              [popperDelay]="1000"
              [popperApplyClass]="customIcon.tooltip?.type ?? null"
              [popperPlacement]="ngxPopperjsPlacements.TOP"
              [popperHideOnScroll]="true"
              [popperPreventOverflow]="false"
              popperAppendTo="body"
              [style.color]="customIcon.color ?? null"
              [ngClass]="customIcon.customClass ?? null"
              >
              <svg-icon [key]="customIcon.key ?? null"></svg-icon>
            </span>
          }
          @if (orchestratorViewModel?.metadata?.rootMetaData?.userMetaData?.securityAccess != null) {
            <span class="icon-field">
              <svg-icon key="locked"></svg-icon>
            </span>
          }
          <div class="truncate truncate-leading">
            <span class="content"
              popper="{{orchestratorViewModel.title}}"
              [popperTrigger]="ngxPopperjsTriggers.hover"
              popperApplyClass="info"
              [popperDelay]="1000"
              [popperPlacement]="ngxPopperjsPlacements.TOP"
              [popperPreventOverflow]="false"
              [popperHideOnScroll]="true"
              popperAppendTo="body"
            >{{orchestratorViewModel.title}}</span>
          </div>
        </div>
      }
    </div>

    @if (showRelatedItemsScrollArea) {
      <nts-text-button (click)="scrollRight()" icon="arrow-forward"></nts-text-button>
    }
    <div class="header-actions-container">
      @if (updateStatus?.status === updateServiceStatusType.UpdatedNeedReload) {
        <div class="update-checker" (click)="onUpdateStatusClicked.emit(updateStatus)" title="Aggiornamento completato, clicca per maggiori informazioni">
          <svg-icon key="refresh-double"></svg-icon>
        </div>
      }
      @if (updateStatus?.status === updateServiceStatusType.Updating) {
        <div class="update-checker updating" (click)="onUpdateStatusClicked.emit(updateStatus)" title="Aggiornamento in corso">
          <svg-icon key="refresh-animated"></svg-icon>
        </div>
      }
      @if (updateStatus?.status === updateServiceStatusType.UpdateError) {
        <div class="update-checker error" (click)="onUpdateStatusClicked.emit(updateStatus)" title="Aggiornamento non riuscito, clicca per maggiori informazioni">
          <svg-icon key="refresh-double"></svg-icon>
        </div>
      }
      @if (orchestratorViewModel.layoutMetaData) {
        <div class="custom-layout" [title]="orchestratorViewModel.currentLayout.displayName">
          <svg-icon key="layout-left"></svg-icon>
        </div>
      }
      @if (showCurrentState) {
        <div
          class="saving-state-container">
          <div class="saving-state">
            <svg-icon [key]="currentStateIconMapping[currentState]"></svg-icon>
            <span
              popper="{{currentStateDescription}}"
              [popperTrigger]="ngxPopperjsTriggers.hover"
              [popperDelay]="1000"
              popperApplyClass="info"
              [popperPlacement]="ngxPopperjsPlacements.TOP"
              [popperPreventOverflow]="false"
              [popperHideOnScroll]="true"
              popperAppendTo="body">
              {{currentStateDescription}}
            </span>
          </div>
        </div>
      }
    </div>
  </div>
  <div class="layout-gutter-right">
  </div>
</div>
